import { combineReducers } from 'redux';
import header from './header';
import home from './home';

export default combineReducers({
  header,
  home
});